module.exports = __webpack_public_path__ + "static/fcra-2019-20-q2-d325865b9e98dee096e4cdf618d5a240.pdf";